import type { ReactNode } from 'react';
import {
  IconBuilding,
  IconBuildingFactory2,
  IconClipboardCheck,
  IconFileDescription,
  IconSearch,
} from '@tabler/icons-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type PartnerKind = 'landlord' | 'oem';

export type SlaWizardStepItem = {
  title: string;
  icon: ReactNode;
};

export function useSlaWizardStepItems(partnerKind: PartnerKind) {
  const { t } = useTranslation('sla');

  return useMemo(
    () => [
      {
        title: t('stepper.partner'),
        icon: <IconSearch size={16} />,
      },
      {
        title: t('stepper.scope'),
        icon:
          partnerKind === 'landlord' ? (
            <IconBuilding size={16} />
          ) : (
            <IconBuildingFactory2 size={16} />
          ),
      },
      {
        title: t('stepper.contract'),
        icon: <IconFileDescription size={16} />,
      },
      {
        title: t('stepper.review'),
        icon: <IconClipboardCheck size={16} />,
      },
    ],
    [partnerKind, t],
  );
}
